/* eslint-disable no-param-reassign */
import qs from 'qs'
import { platform } from '@/utils/platform'
import { getEvnBaseUrl } from '@/utils'
import { getAccessToken, getTenantId } from '@/utils/auth'
const tenantEnable = import.meta.env.VITE_APP_TENANT_ENABLE

const whiteList: string[] = ['/login', '/refresh-token', '/system/tenant/get-id-by-name']

export type CustomRequestOptions = UniApp.RequestOptions & {
  params?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEvnBaseUrl()

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.params) {
      const queryStr = qs.stringify(options.params)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      // console.log(__VITE_APP_PROXY__)
      if (JSON.parse(__VITE_APP_PROXY__)) {
        // 啥都不需要做
      } else {
        options.url = baseUrl + options.url
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      options.url = baseUrl + options.url
      // #endif
      // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    }
    // 1. 请求超时
    options.timeout = 10000 // 10s
    // 2. （可选）添加小程序端请求头标识
    options.header = {
      platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
      ...options.header,
    }
    const method = options.method?.toUpperCase()
    // 防止 GET 请求缓存
    if (method === 'GET') {
      options.header['Cache-Control'] = 'no-cache'
      options.header['Pragma'] = 'no-cache'
    }
    // 自定义参数序列化函数
    else if (method === 'POST') {
      const contentType = options.header['Content-Type'] || options.header['content-type']
      if (contentType === 'application/x-www-form-urlencoded') {
        if (options.data && typeof options.data !== 'string') {
          options.data = qs.stringify(options.data)
        }
      }
    }
    // 3. 添加 token 请求头标识
    let isToken = (options!.header || {}).isToken === false
    isToken = whiteList.some((allowUrl) => options!.url.indexOf(allowUrl) !== -1)

    if (!isToken && getAccessToken()) {
      // 能够获取的到accessToken并且不是白名单
      options.header.Authorization = `Bearer ${getAccessToken()}`
    }

    // 4. 添加租户标识
    if (tenantEnable && tenantEnable === 'true') {
      const tenantId = getTenantId()
      if (tenantId) {
        options.header['tenant-id'] = tenantId
      } else {
        options.header['tenant-id'] = '1'
      }
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
